import { createColumnHelper } from '@tanstack/react-table'
import { NavLink } from 'react-router-dom'
import ActionButton from '../../components/shared/ActionButton'
import { EditIcon, ViewIcon } from '../../components/shared/Icons'
// import formate from 'date-format'
import { formatDate } from '../../utils/formatDate'
const columnHelper = createColumnHelper()
export const columns = [
  columnHelper.accessor('name', {
    header: 'Name',
  }),
  columnHelper.accessor('createdAt', {
    header: 'Created Date',
    cell: (info) => formatDate(info.getValue()),
  }),
  columnHelper.accessor('_id', {
    id: 'View',
    header: <span className="opacity-0">'View'</span>,
    cell: (info) => (
      <NavLink to={`/parentCategory/view/${info.getValue()}`}>
        <ActionButton>
          <ViewIcon />
          View
        </ActionButton>
      </NavLink>
    ),
  }),
  columnHelper.accessor('_id', {
    id: 'edit',
    header: <span className="opacity-0">'Edit'</span>,
    cell: (info) => (
      <NavLink to={`/parentCategory/edit/${info.getValue()}`}>
        <ActionButton className={'text-destructive'}>
          <EditIcon />
          Edit
        </ActionButton>
      </NavLink>
    ),
  }),
]
